import classes from '../Style/Sidebar.scss';
import { Box } from '@mui/material';
import Logo from '../Components/Logo';
import Menu from '../Components/Menu';
import ImportantConceptsMenu from '../Components/ImportantConceptsMenu';
import FeedbackButton from '../Components/FeedbackButton';

import ShareButtons from '../Components/ShareButtons';
import SidebarSvg from './../Components/sidebarSvg';

const Sidebar = (props) => {
	return (
		<Box className='sidebar' sx={{ position: 'sticky', top: 0 , zIndex: 9999,}}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					justifyContent: 'space-between',
				}}
			>
			
				{  <Menu path={props.path} />}
				
				<Box >
					{/* {  <FeedbackButton />} */}
					{  <ShareButtons />}
				</Box>
			</Box>
		</Box>
	);
};

export default Sidebar;
